import React from "react";
import {Box} from "grommet";
import Head from "../Head";
import Notification from "../Notification";
import Footer from "../Footer";

const EmptyLayout = (props) => {
    const {
        children,
        title,
        description,
        isLoading,
        background,
        contentContainerProps,
        hideFooter=false
    } = props;

    /*
        No ThemeProvider here: _app.js already wraps every page in one. Nesting a second
        one mounted a second next-themes provider and a second <Grommet> inside the first,
        and the inner pair never saw the server-side initialTheme, so these pages kept
        rendering light markup for a dark-mode user.
    */
    return (
        <>
            <Head title={title} description={description} />
            <Box responsive={false} background={background || ''}>
                <Notification />
                <Box {...contentContainerProps}>
                    {children}
                </Box>
                {!hideFooter && (
                    <Box flex="grow" pad="small" skeleton={isLoading ? {animation: 'fadeIn'} : undefined }>
                        <Footer />
                    </Box>
                )}
            </Box>
        </>
    );
};

export default EmptyLayout;
